import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { TableSecondary, TableRow, TableData } from 'components/layout/Table'
import { Status } from 'components/misc'
import { assessorAj as assessorLayout } from 'constants/layout/assessor'

export default class AssessorAJParticipantTable extends Component {
  static propTypes = {
    eventParticipants: PropTypes.object
  }

  render() {
    const { eventParticipants } = this.props

    return (
      <TableSecondary ths={assessorLayout.tableHeaders} transposable>
        <TableRow isSingleItem>
          <TableData>
            {get(eventParticipants, 'ajEvent.startDate') && (
              <FormattedDate value={eventParticipants.ajEvent.startDate} />
            )}
          </TableData>
          <TableData>
            {get(eventParticipants, 'ajEvent.endDate') && (
              <FormattedDate value={eventParticipants.ajEvent.endDate} />
            )}
          </TableData>
          <TableData>
            <Status state={eventParticipants.isSentForAssessment} check />
          </TableData>
        </TableRow>
      </TableSecondary>
    )
  }
}
